/**
 * Moves an item from one position to another within an array without mutating the original.
 *
 * Creates a copy of the array and moves the item at the 'from' index to the 'to' index.
 * All other items shift accordingly to maintain array integrity.
 *
 * @param array - The original array (remains unchanged)
 * @param from - Source position index
 * @param to - Destination position index
 * @returns A new array with the item moved to the new position
 *
 * @example
 * ```typescript
 * const items = ['a', 'b', 'c', 'd']
 * moveFromTo(items, 0, 2) // returns ['b', 'c', 'a', 'd']
 * moveFromTo(items, 3, 1) // returns ['a', 'd', 'b', 'c']
 * console.log(items) // still ['a', 'b', 'c', 'd'] (unchanged)
 * ```
 */
export default function moveFromTo(
  array: any[],
  from: number,
  to: number,
): any[] {
  // copy before using .splice() to reorder
  const arrayCopy = array.slice()
  arrayCopy.splice(to, 0, arrayCopy.splice(from, 1)[0])
  return arrayCopy
}
